import {useMutation} from '@apollo/client'
import {Button, Modal, Spinner} from 'react-bootstrap'
import {ACTIVE_INACTIVE_USER} from '../../../graphql/mutations/userMutations'
import {useEffect} from 'react'
import {toast} from 'react-toastify'
import {parseId} from '../../../helpers'
import {IResActiveInactive} from '../../../graphql/types/usersTypes'

interface IModalProps {
  isOpen: boolean
  onClose: () => void
  refetch: () => void
  id: string
  isActive: boolean
}

export const ModalActiveInactive: React.FC<IModalProps> = ({
  id,
  isActive,
  isOpen,
  onClose,
  refetch,
}) => {
  const [gqlActiveInactive, {data, loading, error}] =
    useMutation<IResActiveInactive>(ACTIVE_INACTIVE_USER)

  useEffect(() => {
    if (error) toast.error(`Error: ${error.message}`)
  }, [error])

  useEffect(() => {
    if (!data) return
    if (data.userInactivateActivate.success) {
      toast.success('Usuario actualizado correctamente')
      onClose()
      refetch()
    } else if (data.userInactivateActivate.errors) {
      toast.error(`Error: ${data.userInactivateActivate.errors.message}`)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data])

  const handleDesactive = () => {
    gqlActiveInactive({variables: {input: {id: parseId(id)}}})
  }

  return (
    <Modal show={isOpen} size='lg' onHide={onClose}>
      <Modal.Header onHide={onClose}>
        <Modal.Title>{isActive ? 'Desactivar' : 'Activar'} usuario</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p className='fs-1 text-center'>
          ¿Está seguro que desea{' '}
          <span className='text-uppercase fw-semibold' style={{color: isActive ? 'red' : 'green'}}>
            {isActive ? 'Desactivar' : 'Activar'}
          </span>{' '}
          este usario?
        </p>
      </Modal.Body>
      <Modal.Footer>
        <Button onClick={onClose} variant='secondary'>
          Cancelar
        </Button>
        <Button
          variant={isActive ? 'danger' : 'success'}
          onClick={handleDesactive}
          disabled={loading}
        >
          {loading && <Spinner animation='border' size='sm' className='me-3' />}
          {isActive ? 'Desactivar' : 'Activar'}
        </Button>
      </Modal.Footer>
    </Modal>
  )
}
